export const getAlertsAPIConfig = params => ({
    url: '/api/alerts/',
    method: 'GET',
    params,
});
